function Logo({ variant = 'full', theme = 'light', height = 40 }) {
  if (variant === 'icon') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height={height} width={height} aria-label="Cart Deals">
        <rect width="100" height="100" rx="22" fill="#0C447C"/>
        <g transform="translate(18, 14)">
          <rect x="4" y="18" width="48" height="32" rx="5" fill="none" stroke="#85B7EB" strokeWidth="3"/>
          <line x1="4" y1="30" x2="52" y2="30" stroke="#B5D4F4" strokeWidth="2"/>
          <path d="M4 18 L4 10 Q4 4 10 4 L32 4" stroke="#85B7EB" strokeWidth="3" strokeLinecap="round" fill="none"/>
          <circle cx="14" cy="56" r="5" fill="none" stroke="#85B7EB" strokeWidth="3"/>
          <circle cx="42" cy="56" r="5" fill="none" stroke="#85B7EB" strokeWidth="3"/>
          <circle cx="52" cy="6" r="12" fill="#E24B4A"/>
          <text x="52" y="11" textAnchor="middle" fontFamily="sans-serif" fontSize="11" fontWeight="900" fill="#FCEBEB">½</text>
        </g>
      </svg>
    );
  }

  if (variant === 'stacked') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 110" height={height} aria-label="Cart Deals">
        <g transform="translate(43, 4)">
          <rect x="4" y="18" width="48" height="32" rx="5" fill="none" stroke="#85B7EB" strokeWidth="2.5"/>
          <line x1="4" y1="30" x2="52" y2="30" stroke="#B5D4F4" strokeWidth="1.5"/>
          <path d="M4 18 L4 10 Q4 4 10 4 L32 4" stroke="#85B7EB" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
          <circle cx="14" cy="56" r="5" fill="none" stroke="#85B7EB" strokeWidth="2.5"/>
          <circle cx="42" cy="56" r="5" fill="none" stroke="#85B7EB" strokeWidth="2.5"/>
          <circle cx="52" cy="6" r="10" fill="#E24B4A"/>
          <text x="52" y="11" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fontWeight="800" fill="#FCEBEB">½</text>
        </g>
        <text x="70" y="84" textAnchor="middle" fontFamily="system-ui,sans-serif" fontSize="22" fontWeight="800" fill="#E6F1FB" letterSpacing="-0.5">Cart</text>
        <text x="70" y="84" textAnchor="middle" fontFamily="system-ui,sans-serif" fontSize="22" fontWeight="800" fill="#E24B4A" letterSpacing="-0.5" dx="48">Deals</text>
        <text x="70" y="104" textAnchor="middle" fontFamily="system-ui,sans-serif" fontSize="9" fill="#888780">Live half-price deals</text>
      </svg>
    );
  }

  // variant === 'full'
  const cartColor  = theme === 'dark' ? '#85B7EB' : '#378ADD';
  const lightColor = theme === 'dark' ? '#B5D4F4' : '#85B7EB';
  const cartWord   = theme === 'dark' ? '#E6F1FB' : '#0C447C';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 80" height={height} aria-label="Cart Deals — Live half-price deals">
      <g transform="translate(12, 10)">
        <rect x="4" y="18" width="48" height="32" rx="5" fill="none" stroke={cartColor} strokeWidth="2.5"/>
        <line x1="4" y1="30" x2="52" y2="30" stroke={lightColor} strokeWidth="1.5"/>
        <path d="M4 18 L4 10 Q4 4 10 4 L32 4" stroke={cartColor} strokeWidth="2.5" strokeLinecap="round" fill="none"/>
        <circle cx="14" cy="56" r="5" fill="none" stroke={cartColor} strokeWidth="2.5"/>
        <circle cx="42" cy="56" r="5" fill="none" stroke={cartColor} strokeWidth="2.5"/>
        <circle cx="52" cy="6" r="10" fill="#E24B4A"/>
        <text x="52" y="11" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fontWeight="800" fill="#FCEBEB">½</text>
      </g>
      <text x="82" y="38" fontFamily="system-ui,sans-serif" fontSize="32" fontWeight="800" fill={cartWord} letterSpacing="-0.5">Cart</text>
      <text x="168" y="38" fontFamily="system-ui,sans-serif" fontSize="32" fontWeight="800" fill="#E24B4A" letterSpacing="-0.5">Deals</text>
      <text x="82" y="58" fontFamily="system-ui,sans-serif" fontSize="13" fill="#555">
        <tspan>Live </tspan>
        <tspan fontWeight="700" fill="#E24B4A">half-price deals</tspan>
        <tspan> — Coles · Woolworths · Aldi · Chemist Warehouse</tspan>
      </text>
    </svg>
  );
}

export default Logo;
